import { Injectable } from '@angular/core';
import { FoundingMapItemModel } from '../entities/founding-map-item.model';
import type { FoundingMapFilterKey } from '../types/founding-map-filters';
import { InjectableMapDataStateService } from '@ui/shared/domain-map';

@Injectable({ providedIn: 'root' })
export class FoundingMapMapDataService extends InjectableMapDataStateService<FoundingMapItemModel, FoundingMapFilterKey> {
}
